/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_DurationInputs */



/**
* | output |
* | --- |
* | "Pause Duration (ms)" |
*
* @param {Options_Editor_Pause_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_duration = /** @type {((inputs?: Options_Editor_Pause_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de la pause (ms)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pausendauer (ms)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata della pausa (ms)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длительность паузы (мс)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración de la pausa (ms)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂停时长（毫秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一時停止時間（ミリ秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विराम अवधि (मिलीसेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração da pausa (ms)")
	return /** @type {LocalizedString} */ ("Pause Duration (ms)")
});